import React, { useState, useEffect } from 'react';
import { Dropdown ,Search} from 'semantic-ui-react'
import ReadAxios from '../axiosComponent/read';
import { MyInput } from '../dynamicComponent/myInputs';

const MyVehicleMaster = ({
    field: { name },
    form: { setFieldValue },
    ...props
}) => {
    const [content, setContent] = useState([])
    const [isloading, setisloading] = useState(true)
    useEffect(() => {
        if (props.dataId) {
            ReadAxios({ url: `vehicleMaster/${props.dataId}` }).then((res) => {
                setContent(res)
                setisloading(false)
            })
        } else {
            setisloading(false)
        }
    }, [])
    let options = []
    if (content.length > 0) {
        content.map((object, index) => {
            let temp = {}
            // temp.key = object. vehicleMasterId
            // temp.text = object.vehicleNumber
            // temp.value = object.vehicleNumber
            // temp.extra = object
            temp.key = object. vehicleMasterId
            temp.title = object.vehicleNumber
            temp.raw = object
            return options[index] = temp
        })
    }
    let handleChange = (data,{ result }) => {
        setFieldValue(name, props.idValue ? result.key : result.title)
    }
    let handleSearch = (e, data) => {
        // setFieldValue(name, data.value)
        if (data.value) {
            setisloading(true)
            let searchTerm = data.value
            ReadAxios({ url: 'vehicleMaster', readItems: { searchTerm: searchTerm } })
                .then((result) => {
                    setContent(result.data.resultSet)
                    setisloading(false)
                })
        }
    }
    return (

        <Search
          style={{ margin: "0", padding: "0", width: "100%" }}
          className="search-input-ui"
          loading={isloading}
          onResultSelect={handleChange}
          onSearchChange={handleSearch}
          results={options}
          {...props}
        />

    )
}

export default MyVehicleMaster